import React, { FC, useEffect, useState } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { RecommendedColumn } from '/components/BlockColumns/RecommendedColumn';
import {
  ArticleBlockProps,
  BlockContentJson,
  ColumnContainerJson,
  ColumnsJson,
  RelatedItemsData,
  TrackRecommendedContentFn,
} from '/types';
import { useCwaAxios } from '/utils/cwaAxios';
import useTranslate from '/utils/translations';

import styles from './BlockRecommendedContent.scss';

type RelatedItemsApiResponse =
  | {
      data: RelatedItemsData[];
    }
  | {
      data: {
        related_items: RelatedItemsData[];
      };
    }
  | null;

type BlockRecommendedContentProps = {
  articleId: string;
  trackRecommendedContent: TrackRecommendedContentFn;
};

const BlockRecommendedContent: FC<BlockRecommendedContentProps> = ({
  articleId,
  trackRecommendedContent,
}) => {
  const t = useTranslate();

  const [apiResponse, setApiResponse] = useState(
    null as RelatedItemsApiResponse,
  );

  const cwaAxios = useCwaAxios();

  useEffect(() => {
    cwaAxios
      .get(`/api/content/related-items/${articleId}`)
      .then((resp) => setApiResponse(resp.data));
  }, [cwaAxios, articleId, setApiResponse]);

  if (apiResponse) {
    const columnData: ColumnContainerJson[] = (Array.isArray(apiResponse.data)
      ? apiResponse.data
      : apiResponse.data.related_items
    ).map((data) => ({
      elements: {
        title: data.title,
        image: data.article_image_url,
        date: data.date,
        source: data.source,
        url: data.url,
        contentType: data.contentType,
        slug: data.slug,
      },
      hidden: false,
      name: 'recommended',
      type: 'container',
    }));

    const columns: ColumnsJson = {
      layout: 'equal',
      hidden: false,
      type: 'list',
      list: columnData,
    };

    const blockContent: BlockContentJson = {
      title: {
        hidden: false,
        type: 'html',
        content: t('You might also be interested in...'),
      },
      columns: columns,
    };

    const blockProps: ArticleBlockProps = {
      blockId: '1-block-recommended-content',
      blockBackgroundType: 'bg-grey',
      blockContent: blockContent,
      blockBackgroundOpacity: '0.0',
      blockType: 'block-recommended-content',
      blockLinked: false,
    };

    return (
      <div className={styles['recommended-content']}>
        <ArticleBlock
          {...blockProps}
          titleCentered
          offset={1}
          columns={columns.list.map((column: ColumnContainerJson) => (
            <>
              {column.name === 'recommended' && (
                <RecommendedColumn
                  elements={column.elements}
                  trackRecommendedContent={trackRecommendedContent}
                />
              )}
            </>
          ))}
        />
      </div>
    );
  }

  return <></>;
};

export default BlockRecommendedContent;
